module.exports = "/images/marking-icon-firestop_new.svg?099fe4959ff670a33570b7f4917a742d";